import React, { useEffect, useState } from 'react'
import { Space, Button, Breadcrumb, Input, Form } from 'antd'
import {
  adminUsersUrl,
  errorNotification,
  formatUrl,
  getHeaders
} from '../../config'
import axios from 'axios'
import FilterTable from '../../components/Forms/searchFilter'
import PageLoader from '../../components/Layouts/PageLoader'
import BasicInput from '../../components/Forms/BasicInput'
import PageTitle from 'components/PageTitle'

const { Search } = Input

const Customers = props => {
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(false)
  const [meta, setMeta] = useState({
    previous: null,
    next: null,
    count: 0
  })

  const [state, setState] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: ''
  })

  const structureData = data => {
    return data.map(dep => {
      return {
        ...dep,
        createdAt: new Date(dep.createdAt).toDateString()
      }
    })
  }

  const handleInputChange = stateName => event => {
    setState({ ...state, [stateName]: event.target.value })
  }

  // const getCustomers = (dataUrl = adminUsersUrl) => {
  //   const url = formatUrl(dataUrl)
  //   setLoading(true)
  //   axios
  //     .get(url, { headers: getHeaders() })
  //     .then(res => {
  //       setCustomers(structureData(res.data.results))
  //       setLoading(false)
  //       setMeta({
  //         ...res.data,
  //         results: []
  //       })
  //     })
  //     .catch(() => {
  //       setLoading(false)
  //       errorNotification('Error getting customers, retry.')
  //     })
  // }

  const searchCustomers = (fname, lname, phone, customUrl) => {
    let url = customUrl ? formatUrl(customUrl) : `${adminUsersUrl}/search`

    setLoading(true)
    axios
      .post(
        url,
        {
          firstName: fname,
          lastName: lname,
          phoneNumber: phone
        },
        {
          headers: getHeaders()
        }
      )
      .then(res => {
        setCustomers(structureData(res.data.results))
        setMeta({
          ...res.data,
          results: res.data.results.length
        })
      })
      .catch(() => {
        errorNotification('Error searching for customers, retry.')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    searchCustomers('', '', '', '')
    // eslint-disable-next-line
  }, [])

  const handleDetail = record => {
    // eslint-disable-next-line react/prop-types
    props.history.push(`/customers/${record.id}`)
  }

  const columns = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      width: 120
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      width: 120
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      width: 120
    },
    {
      title: 'Email Address',
      dataIndex: 'email',
      key: 'email',
      width: 150
    },
    {
      title: 'Last Login',
      dataIndex: 'lastLogin',
      key: 'lastLogin',
      width: 150,
      // eslint-disable-next-line react/display-name
      render: (text, record) => (
        <Space size={'middle'}>
          <span>
            {new Date(record.lastLogin).toDateString()} -{' '}
            {new Date(record.lastLogin).toTimeString()}
          </span>
        </Space>
      )
    },
    {
      title: 'Date Joined',
      dataIndex: 'dateJoined',
      key: 'dateJoined',
      width: 150,
      // eslint-disable-next-line react/display-name
      render: (text, record) => (
        <Space size={'middle'}>
          <span>{new Date(record.lastLogin).toDateString()}</span>
        </Space>
      )
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 80,
      // eslint-disable-next-line react/display-name
      render: (text, record) => (
        <Space size="middle">
          {/* eslint-disable-next-line */}
          <a href="" onClick={handleDetail.bind(this, record)}>
            View
          </a>
        </Space>
      )
    }
  ]

  return (
    <PageLoader className="container" loading={loading}>
      <PageTitle title="Customers" />
      <div className="row">
        <div className="col-lg-12">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Our Customers</Breadcrumb.Item>
          </Breadcrumb>
          <br />
          <br />
          <div className="card mb-4rem">
            <div className="card-header">
              <div className="utils__title">
                <span>Our Customers</span>
              </div>
            </div>
            <div className="card-body">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div
                  style={{
                    flex: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    marginBottom: '1rem',
                    width: '100%'
                  }}
                >
                  <Button
                    type="primary"
                    // eslint-disable-next-line react/prop-types
                    onClick={() => props.history.push('/customers/add-new')}
                  >
                    Add New Customer
                  </Button>
                </div>
                <div className="">
                  <Form style={{ margin: '0', padding: 0 }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'start',
                        width: '100%'
                      }}
                    >
                      <div>
                        <BasicInput
                          label=""
                          value={state.firstName}
                          name={'firstName'}
                          placeholder="first name"
                          handleChange={handleInputChange('firstName')}
                          required={false}
                        />
                      </div>
                      <div>
                        <BasicInput
                          label=""
                          value={state.lastName}
                          name={'lastName'}
                          placeholder="last name"
                          handleChange={handleInputChange('lastName')}
                          required={false}
                        />
                      </div>
                      <div style={{ marginLeft: '1rem' }}>
                        <Search
                          placeholder="Search phoone"
                          enterButton="Search"
                          size="middle"
                          value={state.phoneNumber}
                          allowClear
                          onClear={() => searchCustomers('', '', '', '')}
                          onChange={handleInputChange('phoneNumber')}
                          onSearch={value =>
                            searchCustomers(
                              state.firstName,
                              state.lastName,
                              value,
                              ''
                            )
                          }
                        />
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
              <FilterTable
                dataSource={customers}
                columns={columns}
                searchFields={
                  []
                  // ['name', 'email', 'phoneNumber']
                }
                meta={meta}
                getData={url => searchCustomers('', '', '', url)}
              />
            </div>
          </div>
        </div>
      </div>
    </PageLoader>
  )
}

export default Customers
